import React, { Component } from "react";
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import classnames from 'classnames';
import { push } from "connected-react-router";

import TemplateListItem from "./TemplateListItem/TemplateListItem";
import PaginationBlock from "../../ui/PaginationBlock/PaginationBlock";
import Spinner from "../../ui/Spinner/Spinner";
import RequireAuth from "../../layout/HOC/require-auth";

import "./TemplatesList.scss";

import {
  getTemplatesListAsync,
  changeTemplatesPage,
  changeTemplatesLimit,
  goToTemplateCreation,
} from "../../../redux/actions/templatesList";

const mapStateToProps = state => ({
  ...state.templatesList,
});

const mapDispatchToProps = dispatch => ({
  onChangePage: page => dispatch(changeTemplatesPage(page)),
  onChangeDisplayOption: limit => dispatch(changeTemplatesLimit(limit)),
  onCreateTemplate: () => dispatch(goToTemplateCreation()),
  getTemplatesList: payload => dispatch(getTemplatesListAsync(payload)),
  onClickTemplateItem: templateId => dispatch(push(`/template/${templateId}`)),
});

class TemplatesList extends Component {
  static propTypes = {
    ready: PropTypes.bool.isRequired,
    loading: PropTypes.bool.isRequired,
    templates: PropTypes.array.isRequired,
    total: PropTypes.number.isRequired,
    limit: PropTypes.number.isRequired,
    activePage: PropTypes.number.isRequired,
    onChangePage: PropTypes.func.isRequired,
    onChangeDisplayOption: PropTypes.func.isRequired,
    onCreateTemplate: PropTypes.func.isRequired,
    getTemplatesList: PropTypes.func.isRequired,
    onClickTemplateItem: PropTypes.func.isRequired,
  };

  componentDidMount = () => { 
    const { getTemplatesList } = this.props;
    const payload = this.setPayload();
    getTemplatesList(payload);
  }

  //Пагинация и фильтры
  componentDidUpdate = previousProps => {
    const { limit, activePage, getTemplatesList } = this.props;
    const payload = this.setPayload();

    //Условия перезагрузки
    if (
      (previousProps.activePage !== activePage)
      || (previousProps.limit !== limit)
    ) getTemplatesList(payload);
  }

  setPayload = () => {
    const { limit, activePage } = this.props;
    //Пагинация:
    //limit - количество пользователей на одну страницу пагинации
    //page - активная страница
    const payload = {
      limit,
      page: activePage,
      type: [],
    };
    return payload;
  }

  renderTemplatesList = (template, i) => {
    const { onClickTemplateItem } = this.props;
    return(
      <TemplateListItem
        key={`${template.id}_${i}`}
        template={template}
        onClickTemplate={(id) => onClickTemplateItem(id)}
      />
    );
  }

  render() {
    const {
      ready, loading, templates, limit, total, activePage, onChangePage, onChangeDisplayOption, onCreateTemplate,
    } = this.props;

    //Рассчитаем количество страниц пагинации
    const pagesCount = Math.ceil(total / limit);

    const contentClass = classnames({
      'templates-content': true,
      'hollow': templates.length === 0,
    });

    return (
      <div className="templates-wrap">
        <div className="templates-header">
          <button type="button" className="btn btn-green" onClick={() => onCreateTemplate()}>Создать шаблон</button>
        </div>
        {ready ? (
          <React.Fragment>
            <div className={contentClass}>
              {templates.length !== 0 ? 
                templates.map(this.renderTemplatesList)
              : (
                <div className="hollow-text">
                  Здесь пока пусто.<br />
                  Создайте первый шаблон
                </div>
              )}
            </div>
            {templates.length !== 0 ? (
              <div className="templates-footer">
                <PaginationBlock
                  activePage={activePage}
                  pagesCount={pagesCount}
                  pagesVisible={7}
                  onChangePage={onChangePage}
                  displayOptions={[15, 30, 60, 120]}
                  selectedDisplayOption={limit}
                  selectDisplayOption={onChangeDisplayOption}
                />
              </div>
            ) : false}
          </React.Fragment>
        ) : false}
        {loading ? (<Spinner />) : false}
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(RequireAuth(TemplatesList));
